export interface PageSEO {
  title: string;
  description: string;
  keywords: string;
}
export interface SEOStore {
  home: PageSEO;
  catalog: PageSEO;
  contact: PageSEO;
  partner: PageSEO;
}
const DEFAULT_SEO: SEOStore = {
  home: {
    title: 'YAVUZ BURAK — Лакокрасочные материалы в Бишкеке | Краски для фасадов и интерьеров',
    description: 'ОсОО Явуз Бурак — производство и продажа профессиональных лакокрасочных материалов в Бишкеке. Фасадные краски EXTERRA, интерьерные VELORA, микроцемент MICROLUX. Европейское качество.',
    keywords: 'краска Бишкек, лакокрасочные материалы, фасадная краска, интерьерная краска, YAVUZ BURAK, микроцемент, грунтовка'
  },
  catalog: {
    title: 'Каталог продукции YAVUZ BURAK — Краски, грунтовки, микроцемент в Бишкеке',
    description: 'Полный каталог лакокрасочных материалов YAVUZ BURAK: VELORA, EXTERRA, MICROLUX, NEO STONE, STORM FIXERA. Цены, технические характеристики, оформление заказа.',
    keywords: 'каталог красок, VELORA, EXTERRA, MICROLUX, NEO STONE, STORM FIXERA, грунтовка, бетоно-контакт, цены'
  },
  contact: {
    title: 'Контакты YAVUZ BURAK — г. Бишкек, ул. Ю. Фучика 9а',
    description: 'Свяжитесь с YAVUZ BURAK: +996 502 100 636. Адрес: г. Бишкек, ул. Ю. Фучика 9а. Email: info@yavuzburak.kg. Режим работы: Пн-Пт 9:00–18:00. Оставьте заявку онлайн.',
    keywords: 'контакты YAVUZ BURAK, адрес, телефон, Бишкек, ул Фучика'
  },
  partner: {
    title: 'Партнерская программа BM PARTNER — YAVUZ BURAK',
    description: 'Станьте дилером YAVUZ BURAK. Фиксированные цены на 6 месяцев, гарантированные поставки, персональный менеджер. Подайте заявку на партнерство.',
    keywords: 'партнер YAVUZ BURAK, дилер, BM PARTNER, оптовые поставки красок Бишкек'
  }
};
export function getSEO(): SEOStore {
  try {
    const stored = localStorage.getItem('yb_seo');
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        home: {
          ...DEFAULT_SEO.home,
          ...parsed.home
        },
        catalog: {
          ...DEFAULT_SEO.catalog,
          ...parsed.catalog
        },
        contact: {
          ...DEFAULT_SEO.contact,
          ...parsed.contact
        },
        partner: {
          ...DEFAULT_SEO.partner,
          ...parsed.partner
        }
      };
    }
  } catch {}
  return DEFAULT_SEO;
}
export function saveSEO(seo: SEOStore): void {
  localStorage.setItem('yb_seo', JSON.stringify(seo));
}
export function getDefaultSEO(): SEOStore {
  return DEFAULT_SEO;
}